import powerfulCommunication from '../assets/images/stack-icons/powerful-communication-stack.svg';
import projectChangeManagement from '../assets/images/stack-icons/project-change-management-stack.svg';
import highPerformanceTeams from '../assets/images/stack-icons/high-performance-teams-stack.svg';
import crossFunctionalCollaboration from '../assets/images/stack-icons/cross-functional-collaboration-stack.svg';
import accountableTeams from '../assets/images/stack-icons/accountable-teams-stack.svg';
import essentialBusinessSkills from '../assets/images/stack-icons/essential-business-skills-stack.svg';
import diverseEquitableInclusiveTeams from '../assets/images/stack-icons/diverse-equitable-inclusive-teams-stack.svg';
import motivatedTeams from '../assets/images/stack-icons/motivated-teams-stack.svg';
import modernWorkplace from '../assets/images/stack-icons/modern-workplace-stack.svg';
import highPerformanceTeamLeader from '../assets/images/stack-icons/high-performance-team-leader-stack.svg';
import highEq from '../assets/images/stack-icons/high-eq-stack.svg';
import strategicCreativeThinking from '../assets/images/stack-icons/strategic-creative-thinking-stack.svg';
import learnItAllLeader from '../assets/images/stack-icons/learn-it-all-leader-stack.svg';
import presentLikePro from '../assets/images/stack-icons/present-like-pro-stack.svg';
import aiAdvantage from '../assets/images/stack-icons/ai-advantage-stack.svg';
import smallStepsWellness from '../assets/images/stack-icons/small-steps-wellness-stack.svg';

export const stackIcons = {
  powerfulCommunication,
  projectChangeManagement,
  highPerformanceTeams,
  crossFunctionalCollaboration,
  accountableTeams,
  essentialBusinessSkills,
  diverseEquitableInclusiveTeams,
  motivatedTeams,
  modernWorkplace,
  highPerformanceTeamLeader,
  highEq,
  strategicCreativeThinking,
  learnItAllLeader,
  presentLikePro,
  aiAdvantage,
  smallStepsWellness,
};

// Map stack names to their respective icons
export const getStackIconByName = (stackName: string): string => {
  const stackNameToIcon: Record<string, string> = {
    'The Powerful Communication': stackIcons.powerfulCommunication,
    'The Project & Change Management': stackIcons.projectChangeManagement,
    'The High-Performance Teams': stackIcons.highPerformanceTeams,
    'The Cross-Functional Collaboration':
      stackIcons.crossFunctionalCollaboration,
    'The Accountable Teams': stackIcons.accountableTeams,
    'The Essential Business': stackIcons.essentialBusinessSkills,
    'The Diverse, Equitable, and Inclusive Teams':
      stackIcons.diverseEquitableInclusiveTeams,
    'The Motivated Teams': stackIcons.motivatedTeams,
    'The Modern Workplace': stackIcons.modernWorkplace,
    'The High-Performance Teamleader': stackIcons.highPerformanceTeamLeader,
    'The High EQ': stackIcons.highEq,
    'The Strategic & Creative Thinking': stackIcons.strategicCreativeThinking,
    'The Learn-It-All Leader': stackIcons.learnItAllLeader,
    'The Present like a Pro': stackIcons.presentLikePro,
    'The AI Advantage': stackIcons.aiAdvantage,
    'The small steps wellness': stackIcons.smallStepsWellness,
  };

  return stackNameToIcon[stackName] || '';
};
